import type { PricingBootstrap } from './types'

/**
 * Wederverkoper-overrides — port van booking-flow-v2 `applyWederverkoperOverrides`
 * op de office `PricingBootstrap`-shape:
 *  - wederverkoper-SKU naar voren in availableProducts (eerste primary = fallback)
 *  - minimumOrderExBtw → €150 (B2B-minimum, identiek aan booking-flow intern)
 *  - bundelkorting uit (wederverkoper-tarief is al netto)
 *
 * Geverifieerd 2026-06-11 tegen /v1/calculatePrice: WAS-PRIM-VLOERKLEED-WEDERVERKOPER
 * (€13,50/m²) + pakketten WAS-PACK-VLOERKLEEDWEDER-BASIS/PROTECT zitten in de
 * bootstrap. De Apex-prijscascade (PricingService.repriceLead) prijst op SKU.
 */
export const WEDERVERKOPER_SKU = 'WAS-PRIM-VLOERKLEED-WEDERVERKOPER'
export const WEDERVERKOPER_MINIMUM_ORDER_EX_BTW = 150

export function applyWederverkoperOverrides(
  bootstrap: PricingBootstrap | null,
  isWederverkoper: boolean,
): PricingBootstrap | null {
  if (!bootstrap || !isWederverkoper) return bootstrap

  const products = bootstrap.availableProducts
  if (!products) return bootstrap

  const overrideProduct = products.find((p) => p.sku === WEDERVERKOPER_SKU)
  if (!overrideProduct) return bootstrap

  return {
    ...bootstrap,
    availableProducts: [
      overrideProduct,
      ...products.filter((p) => p.sku !== WEDERVERKOPER_SKU),
    ],
    minimumOrderExBtw: WEDERVERKOPER_MINIMUM_ORDER_EX_BTW,
    bundleDiscounts: [],
  }
}

export function bootstrapHasWederverkoper(bootstrap: PricingBootstrap | null): boolean {
  return !!bootstrap?.availableProducts?.some((p) => p.sku === WEDERVERKOPER_SKU)
}
